import React, { useEffect, useState } from "react";
import { Tab, Tabs, IconButton, Button } from "@mui/material";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AutorenewIcon from "@mui/icons-material/Autorenew";

import { SportImgMap } from "../../constants/common-utlits";
import { Sport } from "../../models/sport";
import { Provider } from "../../models/provider";

import "./sports-header.scss";

import API from "../../services";
import { NavLink, useLocation } from "react-router-dom";

import inpaly from "../../assets/images/inplay.svg";
import grid from "../../assets/images/grid-view.svg";
import list from "../../assets/images/list-view.svg";

import { setGridView } from "../../store";
import { connect } from "react-redux";
import { RootState } from "../../models/RootState";

type HeaderProps = {
    provider: Provider;
    setGridView: Function;
    providerId: string;
    balance: number;
};

const SportsHeader: React.FC<HeaderProps> = (props) => {
    const {
        provider,
        setGridView,
        providerId,
        balance,
    } = props;

    const [sports, setSports] = useState<Sport[]>([]);

    const location = useLocation();

    const operatorId = sessionStorage.getItem("psOperatorId");

    const isMobile = window.innerWidth <= 920;

    const specialOperators =
        operatorId === "MPC1" ||
        operatorId === "karabet" ||
        operatorId === "luckystar";

    /**
     * Get currently selected sport from URL.
     *
     * Examples:
     *
     * /lobby/BetFair/inplay
     *                    ^^^^^^
     *
     * /lobby/BetFair/4
     *                  ^
     */
    const getSelectedTab = () => {
        const pathParts = location.pathname.split("/").filter(Boolean);

        // /lobby/{providerId}/inplay
        // /lobby/{providerId}/{sportId}
        // /lobby/{providerId}/{sportId}/{eventId}/{competitionId}/...
        if (
            pathParts.length >= 3 &&
            pathParts[0] === "lobby"
        ) {
            return decodeURIComponent(pathParts[2]);
        }

        return "inplay";
    };

    const selectedTab = getSelectedTab();

    useEffect(() => {
        featchSportsByProvider();
    }, [providerId]);

    useEffect(() => {
        if (specialOperators && isMobile) {
            setGridView(true);
        }
    }, [operatorId, isMobile]);

    const featchSportsByProvider = async () => {
        try {
            const response: any = await API.post("/getsports", {
                operatorId: sessionStorage.getItem("psOperatorId"),
                providerId: sessionStorage.getItem("psProviderId"),
                token: sessionStorage.getItem("psAuthToken"),
            });

            if (response.data.status === "RS_OK") {
                const spList = [...(response.data.sports || [])].sort(
                    (a: Sport, b: Sport) => {
                        const x = a.sportName.toLowerCase();
                        const y = b.sportName.toLowerCase();

                        if (x < y) {
                            return -1;
                        }

                        if (x > y) {
                            return 1;
                        }

                        return 0;
                    }
                );

                setSports(spList);
            } else {
                setSports([]);
                // navigate("/no-access");
            }
        } catch (err) {
            setSports([]);
            // navigate("/no-access");
        }
    };

    return (
        <div
            className={
                specialOperators
                    ? "sport-tab-header1"
                    : "sport-tab-header"
            }
        >
            {sports.length > 0 ? (
              <Tabs
                  value={selectedTab}
                  variant="scrollable"
                  scrollButtons={false}
                  className="sports-tabs"
              >
                  <Tab
                      component={NavLink}
                      to={`/lobby/${providerId}/inplay`}
                      value="inplay"
                      label="Live"
                      icon={
                          <img
                              src={inpaly}
                              alt="Live"
                          />
                      }
                      className="inplay-root"
                  />

                  {sports.map((sport: Sport) => (
                      <Tab
                          key={sport.sportId}
                          component={NavLink}
                          to={`/lobby/${providerId}/${sport.sportId}`}
                          value={String(sport.sportId)}
                          label={sport.sportName}
                          className="tab-root"
                          icon={
                              <img
                                  src={
                                      SportImgMap[
                                          sport.sportId as keyof typeof SportImgMap
                                      ]
                                  }
                                  alt={sport.sportName}
                              />
                          }
                      />
                  ))}
              </Tabs>
            ) : null}
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        providerId: state.auth.providerId,
        grid: state.auth.grid,
        balance: state.sportsBook.balance,
    };
};

const mapDispatchToProps = (dispatch: Function) => {
    return {
        setGridView: (value: boolean) =>
            dispatch(setGridView(value)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SportsHeader);